module.exports = __webpack_public_path__ + "static/media/ic-check.eb593ec9.svg";